import { Injectable } from '@angular/core';
import { UnsafeAction } from 'app/actions/UnsafeAction';
import * as moment from "moment";

/* tslint:disable */
@Injectable()
export class KeepAppointmentActions {

	static SET_KEEP_APPOINTMENT = '[KeepAppointment] set keepAppointment';
	setKeepAppointment(eventStorageId: string, timestamp: moment.Moment, userSetHasVisualQuota: boolean): UnsafeAction {
		return {
			type: KeepAppointmentActions.SET_KEEP_APPOINTMENT,
			payload: {
				eventStorageId: eventStorageId,
				timestamp: timestamp,
				userSetHasVisualQuota: userSetHasVisualQuota
			}
		};
	}
}



// WEBPACK FOOTER //
// ./src/app/components/keep-appointment/keep-appointment.actions.ts